import Deviceid from "@al/deviceid-v2-sdk";

// 简单实现 eventBus 获取 deviceId
const GetDeviceIdEventBus = {
  _events: [],

  deviceId: "",

  _isInitial: false,

  isOnGetDeviceId: false,

  _inInitDeviceId() {
    return new Promise((resolve, reject) => {
      if (this.deviceId) {
        resolve(this.deviceId);
      } else {
        this.isOnGetDeviceId = true;
        Deviceid.get().then((value) => {
          this.deviceId = value;
          this.isOnGetDeviceId = false;
          resolve(this.deviceId);
        });
      }
    });
  },

  listener(handler) {
    if (this.deviceId) {
      handler.call(null, this.deviceId);
      return;
    }
    if (!this._isInitial) {
      this._isInitial = true;
      this._init();
    }
    handler && this._events.push(handler);
  },

  _removeListener() {
    this._events.length = 0;
  },

  _init() {
    this._inInitDeviceId().then((res) => {
      this._events.forEach((item) => item.call(null, res));
      // 消费完毕移除 handler
      this._removeListener();
    });
  },
};

export default GetDeviceIdEventBus;
